import React, { useEffect, useState, useCallback } from 'react';
import { Card, Skeleton, message, Button, Pagination } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ReloadOutlined } from '@ant-design/icons';
import { getAccidentReport } from '../utils/apiService';
import InspectionList from '../components/inspections/InspectionList';

const AccidentReportNew = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
    total: 0,
    hasNextPage: false,
  });
  const [searchTerm, setSearchTerm] = useState('');

  const loadTemplates = async (pageIndex = 0, pageSize = 10, search = '', isSearchQuery = false) => {
    try {
      if (!isSearchQuery) {
        setLoading(true);
      } else {
        setSearchLoading(true);
      }
      const response = await getAccidentReport({ pageIndex, pageSize, searchTerm: search });
      setTemplates(response?.items || (Array.isArray(response) ? response : []));
      setPagination({
        current: response?.currentPage ?? response?.pageIndex ?? pageIndex,
        pageSize: response?.pageSize || pageSize,
        total: response?.totalCount || 0,
        hasNextPage: response?.hasNextPage || false,
      });
    } catch (err) {
      console.error(err);
      message.error('Failed to load accident report templates');
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };

  useEffect(() => {
    loadTemplates(0, pagination.pageSize, '');
  }, []);

  const handlePageChange = (page, pageSize) => {
    loadTemplates(page - 1, pageSize, searchTerm, true);
  };

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
    loadTemplates(0, pagination.pageSize, value, true);
  }, [pagination.pageSize]);

  const handleSelectTemplate = (tpl) => {
    const id = tpl?.id || tpl?.templateId || tpl?.guid;
    if (!id) return message.warning('Template ID not found');
    navigate(`/inspections/templates/${id}`, {
      state: { from: 'accidentReports' },
    });
  };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <Button
          onClick={() => loadTemplates(pagination.current, pagination.pageSize, searchTerm)}
          icon={<ReloadOutlined />}
          loading={loading}
        >
          Refresh
        </Button>
      </div>
      {loading ? (
        <Skeleton active />
      ) : (
        <Card>
          <InspectionList
            templates={templates}
            onSelect={handleSelectTemplate}
            onSearch={handleSearchChange}
            searchValue={searchTerm}
            loading={searchLoading}
          />
          {pagination.total > 0 && (
            <div style={{ marginTop: 16, textAlign: 'right' }}>
              <Pagination
                current={pagination.current + 1}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePageChange}
                showSizeChanger
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} templates`}
              />
            </div>
          )}
        </Card>
      )}
    </div>
  );
};

export default AccidentReportNew;
